import '../App.css';
import PremiumPageHeader from './PremiumPageHeader';

function FormPageLayout({
    moduleLabel = 'ACCOUNTS',
    title,
    subtitle,
    modeLabel,
    headerExtra,
    children,
    headerBackground,
}) {
    return (
        <div className="list-page form-page">
            <div className="premium-page-header-wrap">
                <PremiumPageHeader
                    module={moduleLabel}
                    title={title}
                    subtitle={subtitle}
                    modeLabel={modeLabel}
                    headerBackground={headerBackground}
                />
            </div>

            {headerExtra ? <div className="form-page-header-extra">{headerExtra}</div> : null}

            <div className="form-page-panel">
                {children}
            </div>
        </div>
    );
}

export default FormPageLayout;
